import React, { ReactNode } from 'react';
import { Box, StyleProps } from '@televet/kibble-ui/build/chakra';

interface CardProps extends StyleProps {
  children: ReactNode;
}

export const Card = ({ children, maxWidth = 600, backgroundRepeat = 'no-repeat', ...rest }: CardProps): JSX.Element => {
  return (
    <Box
      backgroundRepeat={backgroundRepeat}
      backgroundColor="background.default"
      boxShadow="lg"
      py={5}
      pl={5}
      maxWidth={maxWidth}
      borderRadius="lg"
      {...rest}
    >
      {children}
    </Box>
  );
};
